import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Optional, Output} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIColorControlComponent),
            multi: true
        }
    ],
    selector: "fui-color-control",
    templateUrl: "./color-control.component.html",
    standalone: false
})
export class FUIColorControlComponent extends FUIAbstractControl {
    @Input() okLabel: string = "fui.color-control.button.ok";
    @Input() resetLabel: string = "fui.color-control.button.reset";
    @Input() allowAlpha: boolean = true;
    @Input() textColor: string;
    @Input() showClearIcon: boolean = false;
    @Output() onClear: EventEmitter<void> = new EventEmitter<void>();

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
